<div class="topdiv">

  <!-- Author- Renuka chama
  16/03/2026
  For creation of  Attributes popup screen in JSuite objects -->
  <div class="agGridOuterDiv">
    <div>
      <div>
        <mat-toolbar class="agGridtoperDiv card" style="
                    background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
            border-right: 1px solid #a9a9a9a8;
            border-left: 1px solid #a9a9a9a8;">

          <label i18n="@@spmsUserReg" class="textColour">Attributes List</label>

          <span class="example-spacer"></span>

          <app-common-button label="Template" title="Download Template" icon="fas fa-download example-icon"
            [critical]="true" [buttonId]="1111" width="110px" (clicked)="downloadTemplate()"
            style="margin-left: 6px; margin-right: 6px">
          </app-common-button>


          <input type="file" #fileInput style="display: none;" (change)="onFileChange($event)">
          <!-- Upload File Button -->
          <app-common-button label="Upload File" title="Upload File" icon="fas fa-upload" [critical]="true"
            [buttonId]="1111" width="110px" (clicked)="fileInput.click()" style="margin-left: 6px; margin-right: 6px">
          </app-common-button>



          <app-common-button label="Download" title="Download" icon="fas fa-download" [critical]="true"
            [buttonId]="1111" width="110px" (clicked)="onBtExport()" style="margin-left: 6px; margin-right: 6px">
          </app-common-button>


          <div class="insertPageNoDiv">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
              <input matInput type="text" (input)="onSearchChange($event.target.value)">
            </mat-form-field>
          </div>

          <div class="selectRecordsDiv" style="width:9.5%">
            <mat-form-field appearance="outline" style="width:100%">
              <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
              <mat-select [(ngModel)]="pagesize" (ngModelChange)="onPageSizeChanged()">
                <mat-option value="10" selected>10</mat-option>
                <mat-option value="200">200</mat-option>
                <mat-option value="300">300</mat-option>
                <mat-option value="400">400</mat-option>
              </mat-select>

            </mat-form-field>
          </div>
          <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
          </div>
          <div class="card pagination paginationButtons btn-rounded">
            <ul>
              <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                  (click)="onBtPrevious()"></em></li>
              <li>{{currentpage}}/{{totalpages}}</li>
              <li class="paginationliicon" style="padding:0;"><em class="fas fa-angle-right waves-effect waves-light"
                  (click)="onBtNext()"></em></li>
            </ul>
          </div>
          <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
          </div>
        </mat-toolbar>
      </div>
      <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs" [animateRows]="true" [pagination]="true" [defaultColDef]="defaultColDef"
        [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
        [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
        [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
        [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()"
        [components]="components" (gridReady)="onGridReady($event)" [hidden]="!true"
        style="height: 30vh;margin-bottom: 3%;">
      </ag-grid-angular>
    </div>
    <div class="row topRowMargins headerStyle" style="margin-top: 0;">
      <div style="margin-left: 15px;">
        <label class="textColour" *ngIf="!onEditButton">Add Attribute</label>
        <label class="textColour" *ngIf="onEditButton">Edit Attribute</label>
      </div>
    </div>
    <form novalidate [formGroup]='validations_form'>
      <div class="row">

        <!-- Field -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Field</mat-label>
            <input matInput formControlName="field" [(ngModel)]="recordObject.field">
          </mat-form-field>
        </div>

        <!-- Type -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type" [(ngModel)]="recordObject.type">
              <mat-option *ngFor="let t of typeList" [value]="t">
                {{t}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Type Value -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Type Value</mat-label>
            <input matInput formControlName="typeValue" [(ngModel)]="recordObject.typeValue">
          </mat-form-field>
        </div>

        <!-- Null -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Null</mat-label>
            <mat-select formControlName="nullValue" [(ngModel)]="recordObject.nullValue">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Key -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Key</mat-label>
            <input matInput formControlName="key" [(ngModel)]="recordObject.key">
          </mat-form-field>
        </div>

        <!-- Default -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Default</mat-label>
            <input matInput formControlName="defaultValue" [(ngModel)]="recordObject.default">
          </mat-form-field>
        </div>

        <!-- Extra -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label>Extra</mat-label>
            <input matInput formControlName="extra" [(ngModel)]="recordObject.extra">
          </mat-form-field>
        </div>

        <div *ngIf="!onEditButton" class="col-lg-3">
          <div style="width: 15%;">
            <label (click)="addWhere()" style="margin-top: 6px;
                    background: green;
                    margin-bottom: auto;
                    padding: 2px 5px 0px 5px;
                    border-radius: 15px;"><em class="fas fa-plus" style="color:
                      antiquewhite;font-size: large;" title="Add Attributes"></em></label>
          </div>
        </div>
        <div *ngIf="onEditButton" class="col-lg-3">

          <app-common-button label="Update" title="Update" [critical]="true" [buttonId]="1111" width="110px"
            (clicked)="addWhere()" style="margin-left: 6px; margin-right: 6px">
          </app-common-button>
        </div>
      </div>
    </form>
    <div class="col-lg">
      <div class="container" style="text-align: center; margin-left: 25px;">
        <div class="row topRowMargins">
          <div class="col-lg-3"></div>
          <div class="col-lg-5">
          </div>
          <div class="col-lg-2">
            <app-common-button label="Save" title="Save" [critical]="true" [buttonId]="1111" width="110px"
              (clicked)="saveAttributes()" style="margin-left: 6px; margin-right: 6px">
            </app-common-button>


          </div>
          <div class="col-lg-2">
            <app-common-button label="Cancel" title="Cancel" [critical]="true" [buttonId]="1111" width="110px"
              (clicked)="cancel()" style="margin-left: 6px; margin-right: 6px">
            </app-common-button>


          </div>

        </div>
      </div>
    </div>
  </div>
</div>